import { ChangeEvent } from 'react';
import { Select } from '@/components/Controls/Select';

interface ReminderLineSelectProps {
  label: string;
  placeholder: string;
  options: { label: string; value: string }[];
  value?: string;
  onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
}

export const ReminderLineSelect = ({
  label,
  placeholder,
  options,
  value,
  onChange,
}: ReminderLineSelectProps) => {
  return (
    <div className="flex-1 min-w-0">
      <div className="text-2sm text-slate-600 font-medium mb-1">
        {label}
        &nbsp;
        <span className="text-red-FF2929 text-[16px]">*</span>
      </div>
      <Select
        selectClassName="h-[36px] w-full bg-gray-FCFCFC dark-mode:bg-coal-500"
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
